import { LocalDate } from "@js-joda/core";
import { PeriodNavigator } from "components/designV2/periodNavigator/periodNavigator";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  formatDayShort,
  formatWeekdayShort,
  getStockholmLocalDateNow,
} from "web-apps/company/components/schedule/utils/schedule.dates";
import { DayCard, DayDate, DayName } from "./scheduleWeekView.styled";
import { ScheduleRowContainer, ScheduleRowLayout } from "../../common/scheduleRow/scheduleRow.styled";

interface Props {
  currentDate: LocalDate;
  onChangeDate: (date: LocalDate) => void;
  weekDays: LocalDate[];
}

const getToday = (): LocalDate => getStockholmLocalDateNow();

export const ScheduleWeekHeaderRow: React.FC<Props> = ({
  currentDate,
  onChangeDate,
  weekDays,
}) => {
  const { i18n } = useTranslation();
  const today = useMemo(getToday, [currentDate]);

  return (
    <ScheduleRowContainer>
      <ScheduleRowLayout $dayCount={7} $isFirstRow>
        <PeriodNavigator
          currentDate={currentDate}
          mode="week"
          onChange={onChangeDate}
          showSubLabel
        />
        {weekDays.map((date) => {
          const isToday = date.equals(today);
          return (
            <DayCard key={date.toString()} $isToday={isToday}>
              <DayName>{formatWeekdayShort(date, i18n.language)}</DayName>
              <DayDate $isToday={isToday}>{formatDayShort(date)}</DayDate>
            </DayCard>
          );
        })}
      </ScheduleRowLayout>
    </ScheduleRowContainer>
  );
};
